import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useMediaQuery } from 'react-responsive';
// import { getEstablishment } from '../../../../../slices/thunks';
import { clearDashboardData } from '../../../slices/fuelSupply/reducer';
import { clearDashboardData as clearFuelTankData } from '../../../slices/fuelTank/reducer';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid } from '@mantine/core';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import HourMeterPowerGenerationEChart from './Widgets/HourMeterPowerGenerationEChart';
import SupplyTypeInfoEChart from './Widgets/SupplyTypeInfoEChart';
import EstablishmentInfo from './Widgets/EstablishmentInfo';
import FuelBalancePowerGenerationEChart from './Widgets/FuelBalancePowerGenerationEChart';
import useRedirectEstablishmentActiveContent from '../../../Components/Hooks/useRedirectEstablishmentActiveContent';
import ResidueBarEChart from './Widgets/ResidueBarEChart';
import ResidueBarEChart2 from './Widgets/ResidueBarEChart2';
import ResidueDonutEChart from './Widgets/ResidueDonutEChart';

function useWindowSize() {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        col: 0,
    });

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            let col = 0;

            if (width >= 1400) col = 6; // xxl
            else if (width >= 1200) col = 8; // xl
            else if (width >= 992) col = 12; // lg
            else if (width >= 768) col = 10; // md
            else if (width >= 576) col = 8; // sm
            else col = 6; // xs

            setSize({
                width,
                height: window.innerHeight,
                col,
            });
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // para ejecutarlo al principio

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return size;
}

const ResidueDashboard = () => {
    const { id: establishmentId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Abastecimiento' },
    ];

    // Clear dashboard data only after navigation is complete to prevent animation flickering
    useEffect(() => {
        // Only clear data if we have a valid establishmentId and it's different from the active one
        if (establishmentId && establishmentId !== 'all') {
            // Small delay to ensure navigation is complete
            const timer = setTimeout(() => {
                dispatch(clearDashboardData());
                dispatch(clearFuelTankData());
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [establishmentId, dispatch]);

    // get selected establishment

    const { establishmentActive } = useSelector(
        createSelector(
            state => state.Profile,
            data => ({
                establishmentActive: data.establishmentActive,
            })
        )
        // shallowEqual
    );

    const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/residue/dashboard');

    // useEffect(() => {
    //     if (establishmentActive) {
    //         if (establishmentId !== establishmentActive.value) {
    //             navigate(
    //                 `/establishment/summary/fuel/${establishmentActive.value}`
    //             );
    //         }
    //     }
    // }, [establishmentId, establishmentActive, navigate]);

    const isMediumOrLarger = useMediaQuery({ minWidth: 768 }); // md comienza en 768px por defecto
    const legendPosition = isMediumOrLarger ? 'right' : 'bottom';

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content mb-10' style={{ paddingBottom: '90px' }}>
                <Container fluid>
                    <BreadCrumb
                        title={'Panel de Residuos'}
                        links={breadcrumbLinks}
                    />
                    <Grid columns={12} className='py-1'>
                        <Grid.Col md={4} sm={24} className='m-0 p-1'>
                            <ResidueBarEChart
                                establishmentId={establishmentId}
                                options={{
                                    xAxis: {
                                        type: 'category',
                                        data: ['2020', '2021', '2022', '2023', '2024']
                                    },
                                    yAxis: {
                                        type: 'value',
                                        min: 0,
                                        max: 100,
                                        axisLabel: {
                                        formatter: value => value + '%'
                                        }
                                    },
                                    series: [
                                        {
                                        type: 'bar',
                                        data: [
                                            { value: 67.9, itemStyle: { color: '#CCAF8F' } },
                                            { value: 60.4, itemStyle: { color: '#CCAF8F' } },
                                            { value: 87.3, itemStyle: { color: '#CCAF8F' } },
                                            { value: 86.6, itemStyle: { color: '#CCAF8F' } },
                                            { value: 90.8, itemStyle: { color: '#A16D3D' } },
                                        ],
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter: '{c}%'
                                        },
                                        barWidth: '40%'
                                        }
                                    ]
                                }}
                                title={'Porcentaje de Valorización Blumar'}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-secondary"]'
                                minHeight={'150px'}
                                maxHeight={'300px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                        <Grid.Col md={4} sm={12} className='m-0 p-1'>
                            <ResidueBarEChart
                                establishmentId={establishmentId}
                                options={{
                                    xAxis: {
                                        type: 'category',
                                        data: ['2022', '2023', '2024']
                                    },
                                    yAxis: {
                                        type: 'value',
                                        min: 0,
                                        max: 60,
                                        axisLabel: {
                                        formatter: value => value + '%'
                                        }
                                    },
                                    series: [
                                        {
                                        type: 'bar',
                                        data: [
                                            { value: 89.0, itemStyle: { color: '#DEAC93' } },
                                            { value: 92.4, itemStyle: { color: '#DEAC93' } },
                                            { value: 92.5, itemStyle: { color: '#BF6041' } },
                                        ],
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter: '{c}%'
                                        },
                                        barWidth: '40%'
                                        }
                                    ]
                                }}
                                title={'Porcentaje Reciclaje Residuos Área Salmones'}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-secondary"]'
                                minHeight={'150px'}
                                maxHeight={'300px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                        <Grid.Col md={4} sm={12} className='m-0 p-1'>
                            <ResidueBarEChart
                                establishmentId={establishmentId}
                                options={{
                                    xAxis: {
                                        type: 'category',
                                        data: ['2022', '2023', '2024']
                                    },
                                    yAxis: {
                                        type: 'value',
                                        min: 0,
                                        max: 60,
                                        axisLabel: {
                                        formatter: value => value + '%'
                                        }
                                    },
                                    series: [
                                        {
                                        type: 'bar',
                                        data: [
                                            { value: 48.4, itemStyle: { color: '#8790AF' } },
                                            { value: 44.7, itemStyle: { color: '#8790AF' } },
                                            { value: 53.9, itemStyle: { color: '#27466F' } },
                                        ],
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter: '{c}%'
                                        },
                                        barWidth: '40%'
                                        }
                                    ]
                                }}
                                title={'Valorización de Residuos Área Pesca'}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-secondary"]'
                                minHeight={'150px'}
                                maxHeight={'300px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                    </Grid>
                    <Grid columns={12} className='py-1'>
                        
                        
                        <Grid.Col md={4} sm={12} className='m-0 p-1'>
                            <ResidueDonutEChart
                                establishmentId={establishmentId}
                                colors={[
                                    '#1F3656',
                                    '#9d9d9b',
                                    '#F0DCD2',
                                    '#BB926A'
                                ]}
                                chartData={
                                    [
                                        {
                                            value: 0,
                                            name: 'Papel y Cartón'
                                        },
                                        {
                                            value: 10,
                                            name: 'Plástico'
                                        },
                                        {
                                            value: 20,
                                            name: 'Metales'
                                        },
                                        {
                                            value: 970,
                                            name: 'Orgánicos'
                                        }
                                    ]
                                }
                                title={'Valorización Blumar Por Tipo de Residuo 2024'}
                                legendPosition={'bottom'}
                                um={'Cantidad'}
                                with_total={false}
                                height={'280px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                        <Grid.Col md={4} sm={12} className='m-0 p-1'>
                            <ResidueDonutEChart
                                establishmentId={establishmentId}
                                colors={[
                                    '#fbf2ec',
                                    '#e8e7ed',
                                    '#d7b7a2',
                                    '#cecece',
                                    '#e6bca5',
                                    '#76778b',
                                    '#b28555',
                                    '#9b9b99',
                                    '#c7774a',
                                    '#112440'
                                ]}
                                chartData={
                                    [
                                        {
                                            value: 228,
                                            name: 'Equipos eléctricos y electrónicos'
                                        },
                                        {
                                            value: 400,
                                            name: 'Neumáticos fuera de uso'
                                        },
                                        {
                                            value: 870,
                                            name: 'Orgánicos domiciliarios'
                                        },
                                        {
                                            value: 0,
                                            name: 'Madera'
                                        },
                                        {
                                            value: 12,
                                            name: 'Papel y cartón'
                                        },
                                        {
                                            value: 20,
                                            name: 'Metales'
                                        },
                                        {
                                            value: 0,
                                            name: 'Plásticos'
                                        },
                                        {
                                            value: 50,
                                            name: 'Basura'
                                        },
                                        {
                                            value: 0,
                                            name: 'Lodos'
                                        },
                                        {
                                            value: 8420,
                                            name: 'Residuos tejidos de animales'
                                        }
                                    ]
                                }
                                title={'Valorización Salmones Por Tipo de Residuo 2024'}
                                legendPosition={'bottom'}
                                um={'Cantidad'}
                                with_total={false}
                                height={'280px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                        <Grid.Col md={4} sm={12} className='m-0 p-1'>
                            <ResidueDonutEChart
                                establishmentId={establishmentId}
                                colors={[
                                    '#F0DCD2',
                                    '#BB926A',
                                    '#1F3656',
                                    '#9d9d9b'
                                ]}
                                chartData={
                                    [
                                        {
                                            value: 160,
                                            name: 'Papel y Cartón'
                                        },
                                        {
                                            value: 150,
                                            name: 'Plástico'
                                        },
                                        {
                                            value: 240,
                                            name: 'Metales'
                                        },
                                        {
                                            value: 150,
                                            name: 'Madera'
                                        }
                                    ]
                                }
                                title={'Valorización Pesca por Tipo Residuo'}
                                legendPosition={'bottom'}
                                um={'Cantidad'}
                                with_total={false}
                                height={'280px'}
                                option={'6M'}
                            />
                        </Grid.Col>
                        {/* <Grid.Col md={12} sm={24} className='m-0 p-1'>
                            <ResidueBarEChart2
                                establishmentId={establishmentId}
                                options={{
                                    legend: {
                                        data: ['Residuo Orgánico', 'Residuo Plástico', 'Residuo Vidrio', 'Residuo Metal'],
                                        bottom: 10
                                    },
                                    tooltip: {
                                        trigger: 'item',
                                        formatter: (params) => {
                                        if (params.seriesName === 'Total') return '';
                                        const totals = [310, 360, 360, 350]; // total por planta (suma residuos)
                                        const total = totals[params.dataIndex];
                                        const percent = total === 0 ? 0 : (params.value / total) * 100;
                                        return `${params.seriesName}<br/>${['Planta 1', 'Planta 2', 'Planta 3', 'Planta 4'][params.dataIndex]}: ${params.value} (${percent.toFixed(1)}%)`;
                                        }
                                    },
                                    grid: {
                                        left: 80,
                                        right: 50,
                                        top: 50,
                                        bottom: 80
                                    },
                                    xAxis: {
                                        type: 'category',
                                        data: ['Plantas de Proceso', 'Centros Cultivo', 'Piscicultura', 'Otros Farming']
                                    },
                                    yAxis: {
                                        type: 'value'
                                    },
                                    series: [
                                        {
                                        name: 'Residuo Orgánico',
                                        type: 'bar',
                                        stack: 'total',
                                        barWidth: '50%',
                                        label: {
                                            show: true,
                                            position: 'inside',
                                            formatter: (params) => {
                                            const totals = [310, 360, 360, 350];
                                            const total = totals[params.dataIndex];
                                            const percent = total === 0 ? 0 : (params.value / total) * 100;
                                            return percent.toFixed(1) + '%';
                                            },
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        },
                                        emphasis: { focus: 'series' },
                                        data: [120, 150, 130, 140],
                                        itemStyle: { color: '#5470C6' }
                                        },
                                        {
                                        name: 'Residuo Plástico',
                                        type: 'bar',
                                        stack: 'total',
                                        barWidth: '50%',
                                        label: {
                                            show: true,
                                            position: 'inside',
                                            formatter: (params) => {
                                            const totals = [310, 360, 360, 350];
                                            const total = totals[params.dataIndex];
                                            const percent = total === 0 ? 0 : (params.value / total) * 100;
                                            return percent.toFixed(1) + '%';
                                            },
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        },
                                        emphasis: { focus: 'series' },
                                        data: [80, 90, 110, 100],
                                        itemStyle: { color: '#91CC75' }
                                        },
                                        {
                                        name: 'Residuo Vidrio',
                                        type: 'bar',
                                        stack: 'total',
                                        barWidth: '50%',
                                        label: {
                                            show: true,
                                            position: 'inside',
                                            formatter: (params) => {
                                            const totals = [310, 360, 360, 350];
                                            const total = totals[params.dataIndex];
                                            const percent = total === 0 ? 0 : (params.value / total) * 100;
                                            return percent.toFixed(1) + '%';
                                            },
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        },
                                        emphasis: { focus: 'series' },
                                        data: [60, 70, 60, 60],
                                        itemStyle: { color: '#FAC858' }
                                        },
                                        {
                                        name: 'Residuo Metal',
                                        type: 'bar',
                                        stack: 'total',
                                        barWidth: '50%',
                                        label: {
                                            show: true,
                                            position: 'inside',
                                            formatter: (params) => {
                                            const totals = [310, 360, 360, 350];
                                            const total = totals[params.dataIndex];
                                            const percent = total === 0 ? 0 : (params.value / total) * 100;
                                            return percent.toFixed(1) + '%';
                                            },
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        },
                                        emphasis: { focus: 'series' },
                                        data: [50, 50, 60, 50],
                                        itemStyle: { color: '#EE6666' }
                                        },
                                        {
                                        name: 'Total',
                                        type: 'bar',
                                        stack: 'total',
                                        barGap: '-100%',
                                        barWidth: '50%',
                                        label: {
                                            show: true,
                                            position: 'top',
                                            formatter: (params) => {
                                            const totals = [310, 360, 360, 350];
                                            return totals[params.dataIndex];
                                            },
                                            fontWeight: 'bold',
                                            color: '#000'
                                        },
                                        itemStyle: { color: 'transparent' },
                                        data: [310, 360, 360, 350],
                                        tooltip: { show: false },
                                        silent: true
                                        }
                                    ]
                                    }
                                }
                                title={'Porcentaje Reciclaje Residuos Área Salmones'}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-secondary"]'
                                minHeight={'150px'}
                                maxHeight={'300px'}
                                option={'6M'}
                            />
                        </Grid.Col> */}
                        {/* <Col md={2} sm={12} className='m-0 p-1'>
                            <LoadingWrapper isLoading={!establishment}>
                                <FuelTankInfoEChart
                                    establishment={establishment}
                                    title={'Saldo de Combustible'}
                                    dataColors='["--vz-primary", "--vz-gray-500"]'
                                    minHeight={'120'}
                                    maxHeight={'300'}
                                    option={'6M'}
                                />
                            </LoadingWrapper>
                        </Col> */}
                    </Grid>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ResidueDashboard;
